<template>
    <Card>
        <template v-slot:title>
            {{ integration.name }}
        </template>
        <template v-slot:description>
            {{ __('actions.edit_thing', {thing: __('general.config_for', {for: store.attributes.name})}) }}
        </template>

        <Alert v-if="$page.props.action === 'link'"
               :title="__('general.additional_information_required')"
               type="light-warning"
               class="mb-5"
        >
            <template v-slot:icon>
                <i class="fas fa-info-circle"/>
            </template>

            {{ __('actions.please_enter_thing', {thing: __('general.required_configuration_values')}) }}
        </Alert>

        <form>
            <slot/>
        </form>

        <template v-slot:footer>
            <div class="d-flex flex-row gap-2">
                <button class="btn btn-primary px-10" @click="$emit('save')" :disabled="disableSave">
                    <span v-if="action === 'link'">
                        <i class="fas fa-arrow-circle-right"/>
                        {{ __('actions.link_thing_to', {thing: __('general.store'), to: integration.name}) }}
                    </span>
                    <span v-else>
                        <i class="fas fa-save"/>
                        {{ __('actions.submit') }}
                    </span>
                </button>
                <button class="btn btn-default btn-hover-warning px-5" @click="cancel">
                    <i class="fas fa-times"/>
                    {{ __('actions.abort') }}
                </button>
            </div>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Alert from "@components/Alert.vue";

export default {
    components: {Alert, Card},

    props: {
        action: {
            type: String,
            default: 'edit'
        },
        disableSave: Boolean
    },

    computed: {
        store() {
            return this.$page.props.store;
        },

        integration() {
            return this.$page.props.integration;
        }
    },

    methods: {
        cancel(clickEvent) {
            this.$emit('cancel', clickEvent)
            if (!clickEvent.defaultPrevented) {
                this.$inertia.visit(this.$route('integration.show', this.integration.code))
            }
        }
    }
}
</script>
